import styled from 'styled-components'
import { Stepper as StepperBase, Step as StepBase } from 'react-form-stepper'

import Button from 'components/Button'

export const Stepper = styled(StepperBase)`
  && {
    max-width: 800px;
    margin: auto;
    padding-top: 0;
    padding-bottom: 0;
    font-family: ${({ theme }) => theme.fontFamily};
  }

  & > div:nth-child(${({ activeStep }) => Number(activeStep) + 1}) {
    span {
      font-weight: bold !important;
    }
  }
`
export const Step = styled(StepBase)`
  && {
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    background-color: ${({ theme }) => theme.colors.backgroundLight};
    cursor: default;

    span {
      color: ${({ theme }) => theme.colors.black};
    }

    &.active {
      background-color: ${({ theme }) => theme.colors.main};
    }

    &.completed {
      background-color: ${({ theme }) => theme.colors.backgroundLight};
    }
  }
`

export const Container = styled.div`
  width: 650px;
  margin: 0 auto;
  margin-top: 40px;

  p {
    margin: 0;
  }
`
export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.black};
  font-size: 22px;
  line-height: 16px;
  text-align: center;
`
export const Subtitle = styled.p`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
`
export const ButtonContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  margin-top: 30px;

  ${Button} {
    width: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
export const DateContainer = styled.div`
  display: flex;
  justify-content: space-between;
`
export const Group = styled.div<{ flexCenter?: boolean }>`
  margin: 30px 0;
  ${({ flexCenter }) =>
    flexCenter &&
    `
  display: flex;
  justify-content: center;`}
`
